class SwiperSliderComponent extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    const swiperEl = this.querySelector('.swiper');

    if (!swiperEl || typeof Swiper === 'undefined') return;

    const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayEnabled = this.dataset.autoplay === 'true' && slidesCount > 1 && !prefersReducedMotion;
    const paginationEnabled = this.dataset.pagination === 'true' && slidesCount > 1;

    const options = {
      loop: slidesCount > 1,
      autoHeight: true,
      speed: 600,
      a11y: {
        enabled: true,
      },
    };

    if (autoplayEnabled) {
      options.autoplay = {
        delay: parseInt(this.dataset.autoplayDelay, 10) || 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    if (paginationEnabled) {
      options.pagination = {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
      };
    }

    this.swiper = new Swiper(swiperEl, options);
  }
}

customElements.define('swiper-slider-component', SwiperSliderComponent);
